
import 'components/catalog.tag'
import 'components/star-rating.tag'
riot.tag2('reviews-list', '  <catalog object="Review" cols="{cols}" reload="true" search="true" sortable="true" store="reviews-list" add="{permission(add, &quot;reviews&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;reviews&quot;, &quot;0001&quot;)}" dblclick="{permission(open, &quot;reviews&quot;, &quot;1000&quot;)}">\n    <yield to="body">\n      <datatable-cell name="id"><a class="open-page-item" href="#reviews/{row.id}" target="_blank">{row.id}</a></datatable-cell>\n      <datatable-cell name="dateTime">{row.dateTimeTitle}</datatable-cell>\n      <datatable-cell name="nameProduct">{row.nameProduct}</datatable-cell>\n      <datatable-cell name="nameUser">{row.nameUser}</datatable-cell>\n      <datatable-cell name="mark">\n        <star-rating count="5" value="{row.mark}"></star-rating>\n      </datatable-cell>\n      <datatable-cell name="likes">{row.likes}</datatable-cell>\n      <datatable-cell name="dislikes">{row.dislikes}</datatable-cell>\n      <datatable-cell name="comment">{row.comment}</datatable-cell>\n      <datatable-cell name="merits">{row.merits}</datatable-cell>\n      <datatable-cell name="demerits">{row.demerits}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function(opts) {
'use strict';

var self = this;

self.mixin('permissions');
self.mixin('remove');
self.collection = 'Review';

self.cols = [{ name: 'id', value: '#' }, { name: 'dateTime', value: 'Дата' }, { name: 'nameProduct', value: 'Наименование товара' }, { name: 'nameUser', value: 'Пользователь' }, { name: 'mark', value: 'Звёзд' }, { name: 'likes', value: 'Лайков' }, { name: 'dislikes', value: 'Дислайков' }, { name: 'comment', value: 'Отзыв' }, { name: 'merits', value: 'Достоинства' }, { name: 'demerits', value: 'Недостатки' }];

self.add = function (e) {
    return riot.route('/reviews/new');
};

self.open = function (e) {
    return riot.route('/reviews/' + e.item.row.id);
};

observable.on('reviews-reload', function () {
    return self.tags.catalog.reload();
});
});


// WEBPACK FOOTER //
// ./pages/reviews/reviews-list.tag